module.exports = __webpack_public_path__ + "static/media/silvasa5.5dec5eab.webp";